import React from "react";
import { useParams, NavLink } from "react-router-dom";
import "./IkoneKategorija.scss";
import { ikoneKategorije, ikonePrimeri } from "../../shared/shared";
import AdManagerSlot from "../../components/AdvModule/AdManagerSlot";
import { useGlobalLocation } from "../../shared/LocationContext";

export default function IkoneKategorija() {
  const { kategorija } = useParams();
  const { location } = useGlobalLocation();

  const katData = ikoneKategorije.find(
    (k) => k.route === `/ikone/${kategorija}`
  );

  const ikone = ikonePrimeri.filter((i) => i.kategorija === kategorija);

  if (!katData) {
    return (
      <div className="kat-page">
        <div className="kat-page__not-found">
          <h2>Kategorija nije pronađena</h2>
          <NavLink to="/" className="kat-page__back">← Početna</NavLink>
        </div>
      </div>
    );
  }

  return (
    <div className="kat-page">

      {/* ── HEADER ── */}
      <div className="kat-page__header" style={{ "--accent": katData.color }}>
        <div className="kat-page__header-inner">
          <div className="kat-page__breadcrumb">
            <NavLink to="/">Početna</NavLink>
            <span> / </span>
            <span>Ikone</span>
            <span> / </span>
            <span>{katData.title}</span>
          </div>
          <div className="kat-page__symbol">{katData.symbol}</div>
          <h1 className="kat-page__title">{katData.titleSr}</h1>
          <p className="kat-page__desc">{katData.desc}</p>
        </div>
      </div>

      {/* ── NAV KATEGORIJA ── */}
      <nav className="kat-page__cat-nav">
        {ikoneKategorije.map((k, i) => (
          <NavLink
            key={i}
            to={k.route}
            className={`kat-page__cat-tab ${k.route === `/ikone/${kategorija}` ? "active" : ""}`}
          >
            <span>{k.symbol}</span> {k.title}
          </NavLink>
        ))}
      </nav>

      <div className="kat-page__body">
        <div className="kat-page__main">

          {/* ── GRID IKONA ── */}
          {ikone.length > 0 ? (
            <div className="kat-page__grid">
              {ikone.map((ikona) => (
                <div key={ikona.id} className="kat-page__card">
                  <div className="kat-page__card-img">
                    <img src={ikona.pic} alt={ikona.title} loading="lazy" />
                    <span className="kat-page__card-badge">{ikona.kategorija}</span>
                  </div>
                  <div className="kat-page__card-body">
                    <h3 className="kat-page__card-title">{ikona.title}</h3>
                    <div className="kat-page__card-meta">
                      <span>{ikona.tehnika}</span>
                      <span>{ikona.dimenzije}</span>
                    </div>
                    <div className="kat-page__card-footer">
                      <span className="kat-page__card-price">{ikona.cena}</span>
                      <button className="kat-page__card-btn">Detalji</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="kat-page__empty">
              <div className="kat-page__empty-symbol">{katData.symbol}</div>
              <h3>Ikone iz ove kategorije su u pripremi</h3>
              <p>Uskoro će biti dostupne ikone iz kategorije <strong>{katData.title}</strong>.</p>
              <NavLink to="/" className="kat-page__back">← Pogledaj sve kategorije</NavLink>
            </div>
          )}

          <div className="banner-wrapper">
            <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1724367417806-0"} />
          </div>

          {/* ── INFO O KATEGORIJI ── */}
          <div className="kat-page__info">
            <h2>O ikonama — {katData.title}</h2>
            <p>
              Ikonopis je posebna slikarska tehnika koja se razvijala u okvirima
              pravoslavne Crkve. Svaka ikona nastaje prema kanonima vizantijske
              umetnosti i pisana je jajnom temperom na dasci od lipe ili tise.
              Zlatni listići koji ukrašavaju oreole svetitelja simbolizuju
              Božansku svetlost.
            </p>
            <p>
              Sve ikone koje su prikazane na ovom sajtu su originalna dela
              srpskih ikonopisaca, rađena prema pravilima pravoslavnog
              ikonopisa.
            </p>
          </div>
        </div>

        <aside className="kat-page__aside">
          <div className="kat-page__aside-kategorije">
            <h3>Sve kategorije</h3>
            {ikoneKategorije.map((k, i) => (
              <NavLink key={i} to={k.route} className="kat-page__aside-link">
                <span className="kat-page__aside-symbol" style={{ background: k.color }}>
                  {k.symbol}
                </span>
                <div>
                  <strong>{k.title}</strong>
                  <p>{k.titleSr}</p>
                </div>
              </NavLink>
            ))}
          </div>
          <div className="banner-wrapper xl_sticky">
            <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1723682121612-0"} />
          </div>
        </aside>
      </div>
    </div>
  );
}
